import { IoLogoInstagram, IoLogoLinkedin, IoLogoFacebook } from "react-icons/io5";
import { PiXLogo } from "react-icons/pi";
import logo from '../assets/images/ishema_logo_light.png';
import {Link} from "react-router-dom";
import { campaign } from "../config/campaign";
import { isEventSalesClosed } from "../utils";

export default function MainFooter() {
    const nextTicketStop =
        campaign.stops.find(
            (stop) => !isEventSalesClosed({ endDate: stop.isoDate, status: "active" })
        ) ?? campaign.stops[0];

    return (
        <footer className={'w-full bg-[#0d0101] text-white p-6 md:p-10'}>
            <div className="grid-cols-1 md:grid-cols-3 grid gap-5 border-b pb-8 border-white/10">
                <div className="w-full">
                    <div className="flex flex-row items-center">
                        <p className={'w-20 text-sm font-black uppercase tracking-[0.14em] text-[#ffb45f]'}>Email Us</p>
                        <div className="h-[1px] w-full bg-white/10"></div>
                    </div>
                    <div className="mt-5 text-white/55">info@ishema.rw</div>
                </div>

                <div className="w-full">
                    <div className="flex flex-row items-center">
                        <p className={'w-20 text-sm font-black uppercase tracking-[0.14em] text-[#ffb45f]'}>Call Us</p>
                        <div className="h-[1px] w-full bg-white/10"></div>
                    </div>
                    <div className="mt-5 text-white/55">+250 792 400 474</div>
                </div>

                <div className="w-full">
                    <div className="flex flex-row items-center">
                        <p className={'w-20 text-sm font-black uppercase tracking-[0.14em] text-[#ffb45f]'}>Find Us</p>
                        <div className="h-[1px] w-full bg-white/10"></div>
                    </div>
                    <div className="mt-5 flex flex-row gap-5 justify-start text-xl text-white/55">
                        <IoLogoFacebook/>
                        <PiXLogo/>
                        <IoLogoLinkedin/>
                        <IoLogoInstagram/>
                    </div>
                </div>
            </div>

            <div className="grid-cols-1 mt-5 md:grid-cols-3 grid gap-5 border-b pb-8 border-white/10">
                <div className="w-full">
                    <div className="flex flex-col items-start gap-2 py-2">
                        <img src={logo} alt={'ISHEMA TICKETS'} className={'w-10'}/>
                        {/*<p className={'text-lg font-black uppercase text-white'}>{campaign.title} {campaign.year}</p>*/}
                        <p className={'text-white/55'}>Powered By Ishema Tickets</p>
                    </div>
                </div>

                <div className="w-full">
                    <div className="flex flex-col items-start gap-2 py-2">
                        <p className={'w-28 text-sm font-black uppercase tracking-[0.14em] text-[#ffb45f]'}>Quick Links</p>
                        <div className="flex flex-wrap w-full">
                            <Link to={`/event/${nextTicketStop.slug}`} className={'text-white/55 w-1/2 transition hover:text-[#ffb45f]'}>Tickets</Link>
                            <Link to={'/'} className={'text-white/55 w-1/2 transition hover:text-[#ffb45f]'}>Tour Stops</Link>
                            <Link to={'/tickets'} className={'text-white/55 w-1/2 transition hover:text-[#ffb45f]'}>My Tickets</Link>
                            <Link to={'/contact-us'} className={'text-white/55 w-1/2 transition hover:text-[#ffb45f]'}>Contact</Link>
                        </div>
                    </div>
                </div>

                <div className="w-full">
                    <div className="flex flex-col items-start gap-2 py-2">
                        <p className={'w-28 text-sm font-black uppercase tracking-[0.14em] text-[#ffb45f]'}>Tour Stops</p>
                        <div className="flex flex-wrap w-full">
                            {campaign.stops.map((stop) => (
                                <Link key={stop.id} to={`/event/${stop.slug}`} className={'text-white/55 w-1/2 transition hover:text-[#ffb45f]'}>
                                    {stop.city}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5 text-sm text-white/45">
                @ Ishema Hub Limited {campaign.year}
            </div>
        </footer>
    );
}
